export enum AddressType {
  Boat = 'Boat',
  Factory = 'Factory',
  FinalDelivery = 'Final Delivery',
  Harbor = 'Harbor',
  Invoicing = 'Invoicing',
  Store = 'Store',
}

export enum ProductType {
  Ordinary = 'Ordinary',
  Utz = 'Utz',
  FairTrade = 'Fair trade',
  RainforestAlliance = 'Rainforest alliance',
  CocoaLife = 'Cocoa Life',
  PremiusCyrian = 'Premius Cyrian',
}

export enum CounterpartyType {
  Bank = 'Bank',
  Customer = 'Customer',
  Forwarder = 'Forwarder',
  ShippingLine = 'Shipping line',
  Verification = 'Verification',
}

export enum BVStatus {
  BA = 'BA',
  BV = 'BV',
  BVRequestMade = 'BV request made',
  BVToAsk = 'BV to ask',
  RequestForExtension = 'Request for extension',
  ReworkRequestMade = 'Rework request made',
}

export enum AnalysisClassification {
  GoodFermented = 'Good fermented',
  FairFermented = 'Fair fermented',
}

export enum LotEventType {
  Update = 'update',
  Analysis = 'analysis',
  Weighing = 'weighing',
  BV = 'bv',
  Fumigation = 'fumigation',
  Proposal = 'proposal',
}

export enum ProposalStatus {
  Withdrawn = 'withdrawn',
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export enum AttachmentType {
  Waybill = 'Waybill',
  BV = 'BV',
  ContractLineItem = 'ContractLineItem',
  CooperativePolygon = 'CooperativePolygon',
  CooperativeLegal = 'CooperativeLegal',
  CV = 'CV',
  CVExecution = 'CVExecution',
  Lot = 'Lot',
  LotAnalysis = 'LotAnalysis',
  LotFumigation = 'LotFumigation',
  LotPledge = 'LotPledge',
  LotWeighing = 'LotWeighing',
  Other = 'Other',
  Transfer = 'Transfer',
}

export enum ContainerType {
  Twenty = '20',
  Forty = '40',
  Conventional = 'conventional',
}

export enum ProductionStatus {
  ToProduce = 'To produce',
  UnderProduction = 'Under production',
  Produced = 'Produced',
}

export enum ProductQuality {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
  G1 = 'G1',
  G2 = 'G2',
  SG = 'SG',
}

export enum TransferStatus {
  Departed = 'departed',
  InTransit = 'in transit',
  Arrived = 'arrived',
}

export enum NoteObjectType {
  Activity = 'Activity',
  Address = 'Address',
  Boarding = 'Boarding',
  BV = 'BV',
  Campaign = 'Campaign',
  Container = 'Container',
  ContractLineItem = 'ContractLineItem',
  Counterparty = 'Counterparty',
  CounterpartyContract = 'CounterpartyContract',
  CV = 'CV',
  CVExecution = 'CVExecution',
  Lot = 'Lot',
  LotAnalysis = 'LotAnalysis',
  LotFumigation = 'LotFumigation',
  LotPledge = 'LotPledge',
  LotProposal = 'LotProposal',
  LotWeighing = 'LotWeighing',
  Product = 'Product',
  Transfer = 'Transfer',
  TransitOrder = 'TransitOrder',
  Waybill = 'Waybill',
}

export enum ProductNatureType {
  Ordinary = 'Ordinary',
  Project = 'Project',
  Mixed = 'Mixed',
  Processed = 'Processed',
  Certified = 'Certified',
  Other = 'Other',
}

export enum WaybillStatusType {
  InProgress = 'IN PROGRESS',
  Refused = 'REFUSED',
  Done = 'DONE',
}

export enum FarmerSourceDocumentType {
  RA = 'RA',
  FT = 'FT',
  MERIDIA_DOCUMENT = 'MERIDIA_DOCUMENT',
}
